<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">Laporan Stok Barang</div>
        <DataTable
          :value="items"
          :paginator="true"
          :loading="loading.main"
          class="p-datatable-outlets"
          :rows="limit"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
          :totalRecords="total_records"
          :lazy="true"
          :first="first"
          @page="onPage"
          @sort="onSort"
        >
          <template #header>
            <div class="filter-container">
              <div class="filter-row">
                <div class="filter-group p-col-3">
                  <InputText
                    id="code-barang"
                    v-model="filter.code"
                    placeholder="Kode Barang"
                    @input="handleFilterInput"
                  />
                </div>
                <div class="filter-group p-col-3">
                  <InputText
                    id="name-barang"
                    v-model="filter.name"
                    placeholder="Nama Barang"
                    @input="handleFilterInput"
                  />
                </div>
                <div class="filter-group checkbox-group p-col-2">
                  <Checkbox
                    id="show-all"
                    v-model="filter.show_all"
                    :binary="true"
                    @change="handleShowAllChange"
                  />
                  <label for="show-all" class="checkbox-label"> Semua </label>
                </div>
                <div class="filter-group p-col-2">
                  <label for="stock-op">Stok</label>
                  <Dropdown
                    id="stock-op"
                    v-model="filter.stock_op"
                    :options="stockOperators"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Operator"
                  />
                </div>
                <div class="filter-group p-col-2">
                  <label for="stock-val">Nilai Stok</label>
                  <InputNumber
                    id="stock-val"
                    v-model="filter.stock_val"
                    :min="0"
                    placeholder="0"
                  />
                </div>
                <div class="filter-group button-group p-col-4">
                  <Button
                    label="Cari"
                    class="p-button-info"
                    icon="pi pi-search"
                    @click="getBarang()"
                    v-shortkey="['enter']"
                    @shortkey="getBarang()"
                  />
                  <Button
                    label="Reset"
                    icon="pi pi-refresh"
                    class="p-button-secondary"
                    @click="resetFilters()"
                    v-tooltip.top="'Reset Filter'"
                  />
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                    @click="printReport()"
                    v-tooltip.top="'Print Laporan Stok Barang'"
                  />
                </div>
              </div>
              <div
                class="summary-section"
                v-if="total_records > 0 || all_stock > 0"
              >
                <div class="summary-card">
                  <div class="summary-item">
                    <label>Total Barang</label>
                    <span class="summary-value">{{
                      total_records | number
                    }}</span>
                  </div>
                  <div class="summary-item">
                    <label>Total Stok</label>
                    <span class="summary-value">{{ all_stock | number }}</span>
                  </div>
                  <div class="summary-item">
                    <label>Total Price</label>
                    <span class="summary-value">{{
                      Math.floor(total_price) | currency
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data barang. Mohon tunggu</template>

          <Column
            header="Umur Barang"
            headerStyle="text-align: center; width: 8rem; min-width: 8rem"
            bodyStyle="text-align: center; width: 8rem; min-width: 8rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.item_age | number }} Hari
              </div>
            </template>
          </Column>
          <Column
            header="Tanggal"
            headerStyle="text-align: center; width: 10rem; min-width: 10rem"
            bodyStyle="text-align: center; width: 10rem; min-width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.doc_date | date }}
              </div>
            </template>
          </Column>
          <Column
            header="Kode Barang"
            headerStyle="text-align: center; width: 10rem; min-width: 10rem"
            bodyStyle="text-align: center; width: 10rem; min-width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.code }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama"
            headerStyle="text-align: center; width: 200px; min-width: 200px; max-width: 250px"
            bodyStyle="text-align: center; width: 200px; min-width: 200px; max-width: 250px"
          >
            <template #body="slotProps">
              <div style="text-align: center" :title="slotProps.data.name">
                {{ truncateText(slotProps.data.name, 25) }}
              </div>
            </template>
          </Column>
          <Column
            header="Harga"
            headerStyle="text-align: center; width: 10rem; min-width: 10rem"
            bodyStyle="text-align: center; width: 10rem; min-width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.price | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Diskon"
            headerStyle="text-align: center; width: 10rem; min-width: 10rem"
            bodyStyle="text-align: center; width: 10rem; min-width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.discount | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Mutasi Masuk"
            headerStyle="text-align: center; width: 8rem; min-width: 8rem"
            bodyStyle="text-align: center; width: 8rem; min-width: 8rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.mutation_inbound | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Mutasi Keluar"
            headerStyle="text-align: center; width: 8rem; min-width: 8rem"
            bodyStyle="text-align: center; width: 8rem; min-width: 8rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.mutation_outbound | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Total Sell"
            headerStyle="text-align: center; width: 8rem; min-width: 8rem"
            bodyStyle="text-align: center; width: 8rem; min-width: 8rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_sell | number }}
              </div>
            </template>
          </Column>
          <Column
            field="stock"
            header="Stok"
            :sortable="true"
            headerStyle="text-align: center; width: 8rem; min-width: 8rem"
            bodyStyle="text-align: center; width: 8rem; min-width: 8rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Stok Price"
            headerStyle="text-align: center; width: 10rem; min-width: 10rem"
            bodyStyle="text-align: center; width: 10rem; min-width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock_price | currency }}
              </div>
            </template>
          </Column>
          <!-- eye logo -->
          <Column
            headerStyle="width: 12rem"
            bodyStyle="text-align: center; overflow: visible"
          >
            <template #body="slotProps">
              <router-link
                :to="{
                  name: 'receiving-detail-all',
                  query: { code: slotProps.data.code }
                }"
              >
                <Button
                  type="button"
                  icon="pi pi-eye"
                  class="p-button-rounded p-mr-2"
                ></Button>
              </router-link>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>
<script>
var moment = require('moment')
import { mapState } from 'vuex'
import { appendStockParam, hasStockFilter } from '@/service/reportItemFilter'
export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: {
        main: false
      },
      filter: {
        code: '',
        name: '',
        show_all: false,
        stock_op: 'gt',
        stock_val: null
      },
      stockOperators: [
        { label: '>', value: 'gt' },
        { label: '>=', value: 'gte' },
        { label: '<', value: 'lt' },
        { label: '<=', value: 'lte' },
        { label: '=', value: 'eq' }
      ],
      items: [],
      limit: 20,
      offset: 0,
      first: 0,
      order_by: '-item_age',
      total_records: 0,
      all_stock: 0,
      total_price: 0,
      $_searchDebounced: null
    }
  },
  mounted() {
    this.initDebouncedSearch()
    this.getBarang()
  },
  beforeDestroy() {
    // Cleanup debounced function
    if (this.$_searchDebounced) {
      this.$_searchDebounced = null
    }
  },
  methods: {
    /**
     * Initialize debounced search function
     */
    initDebouncedSearch() {
      this.$_searchDebounced = this.debounce(() => {
        this.first = 0
        this.offset = 0
        this.getBarang()
      }, 500)
    },

    /**
     * Debounce utility method
     */
    debounce(fn, delay) {
      let timeout
      return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },

    /**
     * Handle filter input changes with debouncing
     */
    handleFilterInput() {
      if (this.$_searchDebounced) {
        this.$_searchDebounced()
      }
    },

    /**
     * Handle "Show All" checkbox change
     */
    handleShowAllChange() {
      // Reset pagination when filter changes
      this.first = 0
      this.offset = 0
      this.getBarang()
    },

    /**
     * Handle DataTable pagination events
     * @param {Object} event - Pagination event from DataTable
     */
    onPage(event) {
      this.getBarang(event)
    },

    /**
     * Handle column sorting
     * @param {Object} event - Sort event from DataTable
     */
    onSort(event) {
      if (event.sortField !== 'stock') {
        return
      }
      this.order_by = event.sortOrder === 1 ? 'stock' : '-stock'
      this.first = 0
      this.offset = 0
      this.getBarang()
    },

    /**
     * Open print view for the current stock report
     */
    printReport() {
      const stockFilterSet = hasStockFilter(this.filter.stock_val)

      const route = this.$router.resolve({
        name: 'print-report-stock-barang',
        query: {
          outlet_id: this.user.outlet_id,
          code: this.filter.code || undefined,
          name: this.filter.name || undefined,
          show_all: this.filter.show_all ? 'true' : undefined,
          stock_op: stockFilterSet ? this.filter.stock_op : undefined,
          stock_val: stockFilterSet ? String(this.filter.stock_val) : undefined,
          order_by: this.order_by,
          limit: this.total_records || this.limit
        }
      })
      window.open(route.href, '_blank')
    },

    /**
     * Fetch items with filters and pagination
     * @param {Object|null} event - DataTable pagination event
     */
    async getBarang(event = null) {
      this.loading.main = true

      // Calculate offset from pagination event
      if (event) {
        this.first = event.first
        this.offset = event.first
      } else {
        // Reset to first page on filter/search
        this.first = 0
        this.offset = 0
      }

      // Build query parameters using URLSearchParams
      const params = new URLSearchParams({
        limit: this.limit,
        offset: this.offset,
        order_by: this.order_by
      })

      // Add filters
      if (this.filter.code) {
        params.append('code', this.filter.code)
      }
      if (this.filter.name) {
        params.append('name', this.filter.name)
      }
      if (this.filter.show_all) {
        params.append('show_all', 'true')
      }
      appendStockParam(params, this.filter.stock_op, this.filter.stock_val)

      const url = `${
        process.env.VUE_APP_API_URL
      }/outlet-items/report-items?${params.toString()}`

      try {
        const response = await this.$http.get(url)

        if (response.status === 200) {
          const data = response.data.data
          this.items = data.items || []
          this.total_records = data.total || 0
          this.all_stock = data.all_stock || 0
          this.total_price = data.total_price || 0
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        console.error('Error fetching items:', error)

        // Extract error message
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat mengambil data'

        this.showToast('error', 'Error', errorMessage)

        // Reset data on error
        this.items = []
        this.total_records = 0
        this.all_stock = 0
        this.total_price = 0
      } finally {
        this.loading.main = false
      }
    },

    /**
     * Reset all filters and reload data
     */
    resetFilters() {
      this.filter.code = ''
      this.filter.name = ''
      this.filter.show_all = false
      this.filter.stock_op = 'gt'
      this.filter.stock_val = null
      this.order_by = '-item_age'
      this.first = 0
      this.offset = 0
      this.getBarang()
    },

    /**
     * Truncate text to specified length and add ellipsis
     * @param {string} text - Text to truncate
     * @param {number} maxLength - Maximum length before truncation
     * @returns {string} Truncated text with ellipsis
     */
    truncateText(text, maxLength) {
      if (!text) return '-'
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}

/* Filter Container */
.filter-container {
  margin-bottom: 1rem;
}

.filter-row {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-group {
  flex: 1;
  min-width: 150px;

  label {
    display: block;
    font-size: 14px;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: auto;
  flex: 0 0 auto;

  .checkbox-label {
    margin: 0;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
  }
}

.button-group {
  display: flex;
  gap: 0.5rem;
  min-width: auto;
  flex: 0 0 auto;
}

/* Summary Section */
.summary-section {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.summary-card {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.summary-item {
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.875rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
    font-weight: 500;
  }

  .summary-value {
    font-size: 1.25rem;
    font-weight: 600;
    color: #495057;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .filter-row {
    flex-direction: column;
  }

  .filter-group {
    width: 100%;
  }

  .button-group {
    width: 100%;

    button {
      flex: 1;
    }
  }
}
</style>
